import { SubscriptionService } from '@/services/subscription'
import { useQuery } from '@tanstack/react-query'

type UseSubscriptionPlanArgs = {
  id: string
  enabled?: boolean
}

export const useSubscriptionPlan = ({
  id,
  enabled = true,
}: UseSubscriptionPlanArgs) => {
  return useQuery({
    queryKey: [SubscriptionService.path, id],
    queryFn: () => SubscriptionService.getSubscriptionPlan(id),
    enabled: enabled && !!id,
  })
}
